import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { ArchwizardModule } from 'angular-archwizard';
import {AppRoutingModule} from './app-routing.module';
// import { ResellerAddComponent } from './views/pages/reseller/reseller-master/reseller-add/reseller-add.component';
import {LayoutModule} from './views/layout/layout.module';
import {AuthGuard} from './core/guard/auth.guard';
import {AppComponent} from './app.component';
import {ErrorPageComponent} from './views/pages/error-page/error-page.component';
import {HIGHLIGHT_OPTIONS} from 'ngx-highlightjs';
import {HttpInterceptorProviders} from "./_helpers/http.interceptor";
import {HttpClientModule,HTTP_INTERCEPTORS} from "@angular/common/http";
import {HashLocationStrategy, LocationStrategy} from '@angular/common';
import { AlertService } from './_services/alert.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
//import { ResellerMasterComponent } from './views/pages/reseller/reseller-master/reseller-master.component';
// import { ResellerCreationComponent } from './views/pages/resellers/reseller-creation/reseller-creation.component';
//import { ResellerComponent } from './views/pages/reseller/reseller.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { AgGridModule } from 'ag-grid-angular';
import { FormsModule } from '@angular/forms';
//import { ResellerBasicComponent } from './views/pages/reseller/reseller-master/reseller-basic/reseller-basic.component';
//import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
//import { ResellerstatusComponent } from './views/pages/reseller/reseller-master/resellerstatus/resellerstatus.component';
import {ReactiveFormsModule} from '@angular/forms';
// import { Task } from './task';
import { RouterModule,  Routes} from '@angular/router';
import { NgbModule,  NgbAlertModule, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
//import { ResellerAccountListComponent } from './views/pages/reseller/reseller-master/reseller-account-list/reseller-account-list.component';
//import { ResellerCreationComponent } from './views/pages/reseller/reseller-master/reseller-creation/reseller-creation.component';
//import { ResellerCreateComponent } from './views/pages/reseller/reseller-master/reseller-create/reseller-create.component';
//import { ResellerEditComponent } from './views/pages/reseller/reseller-master/reseller-edit/reseller-edit.component';
//import { ResellerMdrComponent } from './views/pages/reseller/reseller-master/reseller-mdr/reseller-mdr.component';
//import { ResellerKycUploadComponent } from './views/pages/reseller/reseller-master/reseller-kyc-upload/reseller-kyc-upload.component';
//import { KycDocListComponent } from './views/pages/merchants/merchant-master/merchant-kyc-upload/kyc-doc-list/kyc-doc-list.component';
//import { KycDocListComponent } from './views/pages/reseller/reseller-master/reseller-kyc-upload/kyc-doc-list/kyc-doc-list.component';
import { CustomCommonModule } from "./common/common.module";
import { InternalAuditReportComponent } from './views/pages/internal-audit-report/internal-audit-report.component';
import { FuiIndiaReportComponent } from './views/pages/fui-india-report/fui-india-report.component';
import { RiskAndMonitoringComponent } from './views/pages/risk-and-monitoring/risk-and-monitoring.component';
import { FIRReportComponent } from './views/pages/firreport/firreport.component';
import { IraReportComponent } from './views/pages/ira-report/ira-report.component';
import { OsvReportComponent } from './views/pages/osv-report/osv-report.component';
import { PepReportComponent } from './views/pages/pep-report/pep-report.component';
import { MerchantComplianceComponent } from './views/pages/merchant-compliance/merchant-compliance.component';
import { UserManualComponent } from './views/pages/user-manual/user-manual.component';
import { IntegrationKitComponent } from './views/pages/integration-kit/integration-kit.component';
import { RealTimeRiskMonitorComponent } from './views/pages/real-time-risk-monitor/real-time-risk-monitor.component';
import { ChargeBackComponent } from './views/pages/charge-back/charge-back.component';
import { GrievanceReportComponent } from './views/pages/grievance-report/grievance-report.component';
//import { RiskRegisterComponent } from './views/pages/risk-register/risk-register.component';
//import { MerchantReportComponent } from './views/pages/merchant-report/merchant-report.component';
//import { PepComponent } from './views/pages/pep/pep.component';
//import { KycDocListComponent } from './views/pages/reseller/reseller-master/reseller-kyc-upload/kyc-doc-list-reseller/kyc-doc-list.component';
//import { ResellerBlockedComponent } from './views/pages/reseller/reseller-master/reseller-blocked/reseller-blocked.component';
import { DatePipe } from '@angular/common';
import { NegativeMerchantComponent } from './views/pages/negative-merchant/negative-merchant.component';
import { GrievanceEditComponent } from './views/pages/grievance-report/grievance-edit/grievance-edit.component';
import { PassportCheckComponent } from './views/pages/passport-check/passport-check.component';
import { DocumentsComponent } from './views/pages/documents/documents.component';
import { LoginComponent } from './views/pages/auth/login/login.component';
import { MismatchreportComponent } from './views/pages/mismatchreport/mismatchreport.component';
import { SubmittedBatchComponent } from './views/pages/submitted-batch/submitted-batch.component';
import { PassportcheckImageComponent } from './views/pages/passportcheck-image/passportcheck-image.component';
import { MerchantSummaryComponent } from './views/pages/merchant-summary/merchant-summary.component';

 import { LeadreportComponent } from './views/pages/leadreport/leadreport.component';
import { LeadmasterlistComponent } from './views/pages/leadmasterlist/leadmasterlist.component';
import { CustomerMasterComponent } from './views/pages/customers/customer-master/customer-master.component';
import { CustomersComponent } from './views/pages/customers/customers.component';
import { MerchantsModule } from "./views/pages/merchants/merchants.module";
import { CustomerApproveComponent } from './views/pages/customers/customer-approve/customer-approve.component';
import { CustomerBlockedComponent } from './views/pages/customers/customer-master/customer-blocked/customer-blocked.component';
import { CustomerReportModelComponent } from './views/pages/customers/customer-master/customer-report-model/customer-report-model.component';
import { CustomerEditComponent } from './views/pages/customers/customer-edit/customer-edit.component';
import { CustomerTransactionReportComponent } from './views/pages/customers/customer-transaction-report/customer-transaction-report.component';
import { CustomerWalletLedgerComponent } from './views/pages/customers/customer-wallet-ledger/customer-wallet-ledger.component';
import { CustomerReconciliationReportComponent } from './views/pages/customers/customer-reconciliation-report/customer-reconciliation-report.component';
import { NotapplicableComponent } from './views/pages/notapplicable/notapplicable.component';
import { ScreeningUtilityComponent } from './views/pages/screening-utility/screening-utility.component';
import { ScreeningUtilityAddComponent } from './views/pages/screening-utility/screening-utility-add/screening-utility-add.component';
import { ScreeningUtilityEditComponent } from './views/pages/screening-utility/screening-utility-edit/screening-utility-edit.component';
import { VelocityCheckComponent } from './views/pages/velocity-check/velocity-check.component';
import { CustomerBlockComponent } from './views/pages/customers/customer-block/customer-block.component';
import { WalletTransactionReportComponent } from './views/pages/wallet-transaction-report/wallet-transaction-report.component';
import { ReconciliationReportComponent } from './views/pages/wallet-transaction-report/reconciliation-report/reconciliation-report.component';
import { AgentReconciliationReportComponent } from './views/pages/wallet-transaction-report/reconciliation-report/agent-reconciliation-report/agent-reconciliation-report.component';
import { CustomerWiseReconciliationReportComponent } from './views/pages/wallet-transaction-report/reconciliation-report/customer-wise-reconciliation-report/customer-wise-reconciliation-report.component';
import { RiskAssessmentReportComponent } from './views/pages/velocity-check/risk-assessment-report/risk-assessment-report.component';
import { NameScreeningReportComponent } from './views/pages/velocity-check/name-screening-report/name-screening-report.component';
import { BaselCountryReportComponent } from './views/pages/velocity-check/basel-country-report/basel-country-report.component';
import { ProductManagementComponent } from './views/pages/product-management/product-management.component';
import { ProductAddComponent } from './views/pages/product-management/product-add/product-add.component';
import { ProductEditComponent } from './views/pages/product-management/product-edit/product-edit.component';
import { ProductCategoryManagementComponent } from './views/pages/product-category-management/product-category-management.component';
import { ProductSubcategoryManagementComponent } from './views/pages/product-subcategory-management/product-subcategory-management.component';
import { ProductCategoryAddComponent } from './views/pages/product-category-management/product-category-add/product-category-add.component';
import { ProductCategoryEditComponent } from './views/pages/product-category-management/product-category-edit/product-category-edit.component';
import { ProductSubcategoryAddComponent } from './views/pages/product-subcategory-management/product-subcategory-add/product-subcategory-add.component';
import { ProductSubcategoryEditComponent } from './views/pages/product-subcategory-management/product-subcategory-edit/product-subcategory-edit.component';
import { ProductCategoryModalComponent } from './views/pages/product-category-management/product-category-modal/product-category-modal.component';
import { ProductSubcategoryModalComponent } from './views/pages/product-subcategory-management/product-subcategory-modal/product-subcategory-modal.component';
import { ServiceProviderManagementComponent } from './views/pages/service-provider-management/service-provider-management.component';
import { ServiceProviderAddComponent } from './views/pages/service-provider-management/service-provider-add/service-provider-add.component';
import { ServiceProviderEditComponent } from './views/pages/service-provider-management/service-provider-edit/service-provider-edit.component';
import { ExchangeRatesComponent } from './views/pages/exchange-rates/exchange-rates.component';
import { ExchangeRateEditComponent } from './views/pages/exchange-rates/exchange-rate-edit/exchange-rate-edit.component';
import { CommissionProfileMasterComponent } from './views/pages/commission-profile-master/commission-profile-master.component';
import { CommissionProfileAddComponent } from './views/pages/commission-profile-master/commission-profile-add/commission-profile-add.component';
import { CommissionProfileEditComponent } from './views/pages/commission-profile-master/commission-profile-edit/commission-profile-edit.component';
import { FraudPreventionComponent } from './views/pages/fraud-prevention/fraud-prevention.component';
import { TransactionMasterRuleComponent } from './views/pages/fraud-prevention/transaction-master-rule/transaction-master-rule.component';
import { CountryMasterRuleComponent } from './views/pages/fraud-prevention/country-master-rule/country-master-rule.component';
import { ScreeningConfigurationComponent } from './views/pages/screening-utility/screening-configuration/screening-configuration.component';
import { AuditTrailComponent } from './views/pages/audit-trail/audit-trail.component';
import { TestPageComponent } from './views/pages/screening-utility/test-page/test-page.component';
import { SmartRouterComponent } from './views/pages/smart-router/smart-router.component';
import { MerchantTransactionReportComponent } from './views/pages/merchant-transaction-report/merchant-transaction-report.component';
import { CmaStatementReportComponent } from './views/pages/cma-statement-report/cma-statement-report.component';
import { SettlementReportComponent } from './views/pages/settlement-report/settlement-report.component';
import { MerchantAccountComponent } from './views/pages/payment-gateway/merchant-account/merchant-account.component';
import { MerchantAccountEditComponent } from './views/pages/payment-gateway/merchant-account-edit/merchant-account-edit.component';
import { MerchantMappingComponent } from './views/pages/payment-gateway/merchant-mapping/merchant-mapping.component';
import { TdrSettingComponent } from './views/pages/payment-gateway/tdr-setting/tdr-setting.component';
import { RuleEngineComponent } from './views/pages/payment-gateway/rule-engine/rule-engine.component';
import { DocumentComponent } from './views/pages/document/document.component';
import { FrmComponent } from './views/pages/payment-gateway/frm/frm.component';
import { QrCodeGenerationComponent } from './views/pages/qr-code-generation/qr-code-generation.component';
import { CustomerDashboardComponent } from './views/pages/user-dashboard/customer-dashboard/customer-dashboard.component';
import { MerchantDashboardComponent } from './views/pages/user-dashboard/merchant-dashboard/merchant-dashboard.component';
import { LedgerOnlyComponent } from './views/pages/super-transactions/ledger-only/ledger-only.component';
import { LedgerBankComponent } from './views/pages/super-transactions/ledger-bank/ledger-bank.component';
import { SuperTransactionListComponent } from './views/pages/super-transactions/super-transaction-list/super-transaction-list.component';
import { CustomerEventComponent } from './views/pages/customers/customer-event/customer-event.component';
import { TfaSetupComponent } from './views/pages/auth/tfa-setup/tfa-setup.component';
import { TfaVerifyComponent } from './views/pages/auth/tfa-verify/tfa-verify.component';
import { TfaGuard } from './core/guard/tfa.guard';
import { MatCheckbox, MatCheckboxModule } from '@angular/material/checkbox';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FeatherIconModule } from './core/feather-icon/feather-icon.module';

// PII Components for customer pagess
import { PiiFieldComponent } from './common/pii-field/pii-field.component';
import { PiiImageFieldComponent } from './common/pii-image/pii-image-field.component';
import { PiiPdfViewerComponent } from './common/pii-pdf-viewer/pii-pdf-viewer.component';
import { PiiUnhideModalComponent } from './common/pii-unhide-modal/pii-unhide-modal.component';
import { PiiTableComponent } from './common/pii-table/pii-table.component';
import { PiiCellRendererComponent } from './common/pii-cell-renderer.component';
import {UnblockRequestModalComponent} from './common/unblock-request/unblock-request-modal.component';
import {BlockEntityManagementComponent} from './views/pages/block-entity-management/block-entity-management.component';
import { MaskPipe } from './common/pipes/mask.pipe';
import { UserActivityComponent } from './views/pages/user-activity/user-activity.component';
import { OnholdTransactionReportComponent } from './views/pages/onhold-transaction-report/onhold-transaction-report.component';
import { DeveloperReportComponent } from './views/pages/developer-report/developer-report.component';
import { VatInvoiceComponent } from './views/pages/vat-invoice/vat-invoice.component';
import { RemittanceEarningReportComponent } from './views/pages/remittance-reports/remittance-earning-report/remittance-earning-report.component';
import { ViewHierarchyComponent } from './views/pages/view-hierarchy/view-hierarchy.component';
import { CustomerRemittanceReportComponent } from './views/pages/remittance-reports/customer-remittance-report/customer-remittance-report.component';
import { RemittanceReportsComponent } from './views/pages/remittance-reports/remittance-reports.component';
import {CrossBorderTransactionReportComponent} from "./views/pages/fx-report/cross-border-transaction-report/cross-border-transaction-report.component";
import { TopupActionComponent } from './views/pages/customers/customer-transaction-report/topup-action/topup-action.component';
import { MerchantWithdrawlReportComponent } from './views/pages/merchant-withdrawl-report/merchant-withdrawl-report.component';
import { MerchantWithdrawalActionComponent } from './views/pages/merchant-withdrawl-report/merchant-withdrawal-action/merchant-withdrawal-action.component';
import { TransactionReportComponent } from './views/pages/transaction/transaction-report/all/transaction-report.component';
import { TransactionFilterComponent } from './views/pages/transaction/transaction-report/all/filter/transaction-filter.component';
import { WalletReportComponent } from './views/pages/transaction/wallet-report/wallet-report.component';

@NgModule({
    declarations: [
        AppComponent,
        ErrorPageComponent,
        TfaSetupComponent,
        TfaVerifyComponent,
        InternalAuditReportComponent,
        FuiIndiaReportComponent,
        RiskAndMonitoringComponent,
        FIRReportComponent,
        IraReportComponent,
        OsvReportComponent,
        PepReportComponent,
        MerchantComplianceComponent,
        UserManualComponent,
        IntegrationKitComponent,
        RealTimeRiskMonitorComponent,
        ChargeBackComponent,
        GrievanceReportComponent,
        NegativeMerchantComponent,
        GrievanceEditComponent,
        PassportCheckComponent,
        DocumentsComponent,
        MismatchreportComponent,
        SubmittedBatchComponent,
        PassportcheckImageComponent,
        MerchantSummaryComponent,
        LeadreportComponent,
        UserActivityComponent,
        CustomerEventComponent,
        LeadmasterlistComponent,
        CustomerMasterComponent,
        CustomersComponent,
        CustomerApproveComponent,
        CustomerBlockedComponent,
        BlockEntityManagementComponent,
        CustomerReportModelComponent,
        CustomerEditComponent,
        CustomerTransactionReportComponent,
        CustomerWalletLedgerComponent,
        CustomerReconciliationReportComponent,
        NotapplicableComponent,
        ScreeningUtilityComponent,
        ScreeningUtilityAddComponent,
        ScreeningUtilityEditComponent,
        VelocityCheckComponent,
        CustomerBlockComponent,
        WalletTransactionReportComponent,
        ReconciliationReportComponent,
        AgentReconciliationReportComponent,
        CustomerWiseReconciliationReportComponent,
        RiskAssessmentReportComponent,
        NameScreeningReportComponent,
        BaselCountryReportComponent,
        ProductManagementComponent,
        ProductAddComponent,
        ProductEditComponent,
        ProductCategoryManagementComponent,
        ProductSubcategoryManagementComponent,
        ProductCategoryAddComponent,
        ProductCategoryEditComponent,
        ProductSubcategoryAddComponent,
        ProductSubcategoryEditComponent,
        ProductCategoryModalComponent,
        ProductSubcategoryModalComponent,
        ServiceProviderManagementComponent,
        ServiceProviderAddComponent,
        ServiceProviderEditComponent,
        ExchangeRatesComponent,
        ExchangeRateEditComponent,
        CommissionProfileMasterComponent,
        CommissionProfileAddComponent,
        CommissionProfileEditComponent,
        FraudPreventionComponent,
        TransactionMasterRuleComponent,
        CountryMasterRuleComponent,
        ScreeningConfigurationComponent,
        AuditTrailComponent,
        TestPageComponent,
        SmartRouterComponent,
        MerchantTransactionReportComponent,
        CmaStatementReportComponent,
        SettlementReportComponent,
        MerchantAccountComponent,
        MerchantAccountEditComponent,
        MerchantMappingComponent,
        TdrSettingComponent,
        RuleEngineComponent,
        DocumentComponent,
        FrmComponent,
        QrCodeGenerationComponent,
        CustomerDashboardComponent,
        MerchantDashboardComponent,
        LedgerOnlyComponent,
        LedgerBankComponent,
        SuperTransactionListComponent,
        UserActivityComponent,

        // PII Components for customer pages
        PiiFieldComponent,
        PiiImageFieldComponent,
        PiiPdfViewerComponent,
        PiiUnhideModalComponent,
        PiiTableComponent,
        PiiCellRendererComponent,
        MaskPipe,
        OnholdTransactionReportComponent,
        DeveloperReportComponent,
        UserActivityComponent,
        VatInvoiceComponent,
        RemittanceEarningReportComponent,
        UnblockRequestModalComponent,
        ViewHierarchyComponent,
        CustomerRemittanceReportComponent,
        RemittanceReportsComponent,
        CrossBorderTransactionReportComponent,
        //RiskRegisterComponent,
        // MerchantReportComponent,
        // KycDocListComponent,
        TopupActionComponent,
        MerchantWithdrawlReportComponent,
        MerchantWithdrawalActionComponent,
        TransactionReportComponent,
        TransactionFilterComponent,
        WalletReportComponent
    ],
    entryComponents: [],
    providers: [
        LoginComponent, AuthGuard, TfaGuard, HttpInterceptorProviders, NgbActiveModal,
        {
            provide: [HIGHLIGHT_OPTIONS, HTTP_INTERCEPTORS], multi: true,
            useValue: {
                coreLibraryLoader: () => import('highlight.js/lib/core'),
                languages: {
                    xml: () => import('highlight.js/lib/languages/xml'),
                    typescript: () => import('highlight.js/lib/languages/typescript'),
                    scss: () => import('highlight.js/lib/languages/scss'),
                }
            }
        },
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        AlertService, DatePipe
    ],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        LayoutModule,
        HttpClientModule,
        NgSelectModule,
        AgGridModule,
        FormsModule,
        ReactiveFormsModule,
        ArchwizardModule,
        NgbModule,
        RouterModule,
        CustomCommonModule,
        MerchantsModule,
        NgbAlertModule, NgbDatepickerModule,
        MatCheckboxModule,
        DragDropModule,
        FeatherIconModule

    ]
})
export class AppModule {
  constructor() {
  }
}
